import { Injectable } from '@angular/core';

export interface Credentials {
    access: string;
}

@Injectable({
    providedIn: 'root'
})
export class CredentialsService {
    private _credentials: Credentials | null = null;

    /**
     * Vérifie que l'utilisateur est connecté
     * @return True si l'utilisateur est connecté
     */
    isAuthenticated(): boolean {
        return !!this._credentials;
    }

    /**
     * Renvoie les identifiants de l'utilisateur
     * @return Les identifiants ou null si l'utilisateur n'est pas connecté
     */
    get credentials(): Credentials | null {
        return this._credentials;
    }

    /**
     * Définit l'access token en mémoire uniquement.
     * Le refresh token est géré via HttpOnly cookie côté serveur.
     * @param credentials L'access token. Undefined pour déconnecter.
     */
    setCredentials(credentials?: Credentials) {
        this._credentials = credentials || null;
    }
}
